<template>
  <CardCollapse :title="$t('global.auto-scaling-usage-details')" v-on:update:toggle="onToggle">
    <LoadingState v-if="isLoading()" :size="SIZE" class="pt-2" />
    <ErrorState v-else-if="isErrored()" class="pt-2" />
    <CardTabledList v-else-if="usage" :items="getItems()" />
  </CardCollapse>
</template>

<script>
import CardCollapse from "@/components/display/card-sub-components/CardCollapse";
import CardTabledList from "@/components/display/card-sub-components/CardTabledList";
import { computed } from "@vue/composition-api";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import { minutesFormat } from "leatherman-js/utils/formatters/time";
import { moneyFormat } from "leatherman-js/utils/formatters/money";
import NavLink from "@/classes/NavLink";
import store from "@/store";

export default {
  name: "AutoScaleUsage",
  props: {
    site: {
      type: Object,
      required: true,
    },
  },
  components: {
    CardCollapse,
    CardTabledList,
    ErrorState,
    LoadingState,
  },
  setup(props, { root }) {
    const getItems = () => [
      {
        key: root.$t("global.auto-scaling-usage-free-time-left"),
        value: minutesFormat(usage.value.minutesGraceEnd),
        help: {
          header: root.$t("global.cloud-auto-scaling"),
          title: root.$t("global.auto-scaling-usage-free-time-left"),
          message: root.$t("global.auto-scaling-free-time-help-message"),
          link: freeTimeHelpLink,
        },
      },
      {
        key: root.$t("global.auto-scaling-usage-billed-time-spent"),
        value: minutesFormat(usage.value.billableUsed),
      },
      {
        key: root.$t("global.amount"),
        value: moneyFormat(usage.value.billableCost),
      },
    ];
    const isErrored = () => usageStatus.value.isErrored;
    const isLoading = () => usageStatus.value.isLoading || usageStatus.value.isUpdating;
    const onToggle = (show) => {
      if (show) {
        store.dispatch("sites/getAutoScaleUsage", props.site.id);
      }
    };
    const SIZE = 40;
    const usage = computed(() => store.getters["sites/getAutoScaleUsage"]);
    const usageStatus = computed(() => store.getters["sites/getAutoScaleUsageStatus"]);

    const freeTimeHelpLink = [
      new NavLink(
        root.$t("global.learn-more"),
        null,
        function () {
          window.open(
            "https://help.nexcess.net/client-portal/what-is-nexcess-cloud-auto-scaling?from_search=49181016",
            "_blank"
          );
        },
        false,
        null,
        null
      ),
    ];

    return {
      freeTimeHelpLink,
      isLoading,
      isErrored,
      getItems,
      onToggle,
      SIZE,
      usage,
    };
  },
};
</script>
